import tinymce from 'tinymce';
import manager from 'app/module46/component-manager.js';

manager.register('wysiwyg', (component, elements, attributes, properties) => {
	
	const target = (component.tagName === 'TEXTAREA')
				 ? component
				 : component.querySelector('textarea');
	
	tinymce.init(Object.assign({
		target,
		language: 'fr',
		width: '100%',
		entity_encoding: "raw",
		convert_urls: false,
		plugins: [
			'lists link',
		],
		verify_html: true,
		toolbar: [
			"removeformat | bold italic underline | bullist outdent indent | link",
		],
		skin: false,
		content_css: '/dist/wysiwyg.css',
		body_class: "wysiwyg",
		menubar: false,
		textcolor_cols: 8,
		textcolor_rows: 5,
		height: 305,
	}, properties));
});
